var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1306.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Index",
    transform: "translate(5026.000000, 1306.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3 C2.709,3 4.5,4.791 4.5,7 L4.5,25 L27.5,25 C29.709,25 31.5,26.791 31.5,29 L4.5,29 C2.291,29 0.5,27.209 0.5,25 L0.5,3 Z M14.0679,11.4474 L20.0609,17.4394 L17.9399,19.5604 L13.9319,15.5524 L7.2959,21.3584 C6.2049,20.1114 6.3309,18.2154 7.5779,17.1254 L14.0679,11.4474 Z M29.4971,6 L29.4971,17 C27.8401,17 26.4971,15.657 26.4971,14 L26.4971,11.122 L21.1011,16.52 L18.9791,14.399 L24.3761,9 L21.4971,9 C19.8401,9 18.4971,7.657 18.4971,6 L29.4971,6 Z",
    id: 18
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsIndex);
export default __webpack_public_path__ + "static/media/investments-index.3bc91484.svg";
export { ForwardRef as ReactComponent };